export default __webpack_public_path__ + "static/media/shipping-boxes.cff99928.png";